// The order in this list does NOT matter.
// Use it to easily visualize the order of layers

export const zIndex = {
  GLASSES: 270,
  PIERCINGS: 260,
  HAIR: 250,
  EYEBROWS: 240,
  NOSE: 230,
  BEARD: 220,
  MOUTH: 210,
  EYES: 200,
  MARKS: 190,
  FACE: 180,
  COMPLEMENTSB: 45,
  COMPLEMENTSF: 170,
  ARMF3: 160,
  ARMF2: 155,
  ARMF1: 150,
  ARMF: 140,
  ARMF1B: 130,
  ARMF2B: 125,
  ARMF3B: 120,
  TOP3: 110,
  SUSPENDERS: 99,
  TOP2: 100,
  PANTS: 98,
  SHOESF: 97,
  PANTSSLIM: 95,
  SHOESB: 92,
  TOP1: 90,
  NECK: 85,
  BODY: 80,
  TOP1B: 70,
  TOP2B: 60,
  TOP3B: 50,
  ARMB3: 30,
  ARMB2: 26,
  ARMB1: 23,
  ARMB: 20,
  ARMB1B: 17,
  ARMB2B: 14,
  ARMB3B: 11,
  HAIRB: 9
};
